import { useApi, useMutation } from '../../../shared/hooks/useApi';
import { conciergeService } from '../services/conciergeService';
import { ConciergeData } from '../types';

export function useConciergeData(museumCode: string | undefined) {
  return useApi(() => conciergeService.getConciergeData(museumCode!), [museumCode], !!museumCode);
}

export function useUpdateConciergeSection() {
  return useMutation(
    ({
      museumCode,
      section,
      data,
    }: {
      museumCode: string;
      section: keyof ConciergeData;
      data: ConciergeData[keyof ConciergeData];
    }) => conciergeService.updateConciergeSection(museumCode, section, data),
    {
      onError: error => {
        console.error('Failed to update concierge section:', error);
      },
    },
  );
}
